import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class WorkStationSelectorViewModel extends SelectorBaseViewModel<WorkStation> {
    constructor(parentViewModel: ViewModel, id: string = null) {
        super(parentViewModel);
        this.productLineId = id;
    }

    public set productLineId(v: string) { this._productLineId = v; } public get productLineId(): string { return this._productLineId; } private _productLineId: string;

    protected async loadData(): Promise<WorkStation[]> {
        if (this.productLineId != null) {
            let result = await ServerConnection.callServer('/Complex/ProductLineServices/GetAllProductLineWorkStations', {
                ProductLineId: this.productLineId
            })
            return result.WorkStations.map(x => {
                let w = new WorkStation(this);
                w.id = x.WorkStationId;
                w.title = `${x.Name} (${x.Code})`;
                return w;
            });
        }
        return [];
    }
}

export class WorkStation extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}